/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Free_CtaInputs */

const en_mk_price_free_cta = /** @type {(inputs: Mk_Price_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try for free`)
};

const id_mk_price_free_cta = /** @type {(inputs: Mk_Price_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba gratis`)
};

/**
* | output |
* | --- |
* | "Try for free" |
*
* @param {Mk_Price_Free_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_free_cta = /** @type {((inputs?: Mk_Price_Free_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Free_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_free_cta(inputs)
	return en_mk_price_free_cta(inputs)
});